<template>
    <div>
        <h2>{{ title }}</h2>
        <div class="appSwiperContainer">
            <div class="pf_containerSwiper">
                <div class="arrow left">
                    <img alt="leftArrow" class="leftArrow"
                         src="/svg/leftArrow.png" @click="prev"
                    />
                </div>
                <swiper ref="swiper" :options="swiperOptions" class="swiper">
                    <swiper-slide v-for="slide of slides" :key="slide.id" class="slide">
                        <a :href="slide.documentURL" target="_blank">
                            <img :src="slide.iconURL" :alt="slide.documentName"/>
                        </a>
                    </swiper-slide>
                    <div slot="pagination" class="swiper-pagination"/>
                </swiper>
                <div class="arrow right">
                    <img alt="rightArrow" class="rightArrow"
                         src="/svg/rightArrow.png" @click="next"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Swiper, SwiperSlide} from "vue-awesome-swiper";

export default {
    props: ["title", "slides", "mode"],
    methods: {
        next() {
            this.$refs.swiper.$swiper.slideNext();
        },
        prev() {
            this.$refs.swiper.$swiper.slidePrev();
        },
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            swiperOptions: {
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                slidesPerView: 6,
                spaceBetween: 10,
            },
        };
    },
};
</script>

<style lang="scss" scoped>
.appSwiperContainer {
    margin-bottom: 2rem;
    padding: 0 3.5em;

    .arrow {
        cursor: pointer;
        position: absolute;
        width: 40px;
        top: calc(50% - 1.1em);

        &.left {
            left: -50px;
        }

        &.right {
            padding-left: 20px;
            right: -50px;
        }
    }

    .leftArrow {
        width: 0;
        height: 0;
        border-top: 0.8em solid transparent;
        border-bottom: 0.8em solid transparent;
        border-right: 1.5em solid var(--main-red);
    }

    .rightArrow {
        width: 0;
        height: 0;
        border-top: 0.8em solid transparent;
        border-bottom: 0.8em solid transparent;
        border-left: 1.5em solid var(--main-red);
    }
}

h2 {
    font-size: 1.7em;
    color: var(--main-red);
    margin-top: 30px;
    margin-bottom: 20px;
    margin-left: 50px;
}

.pf_containerSwiper {
    margin: auto;
    position: relative;
}

.swiper {
    height: 100%;
    width: 100%;

    .slide {
        cursor: pointer;

        img {
            width: 90%;
            margin: 0 auto;
            aspect-ratio: 21 / 29.7;
        }
    }

    .swiper-slide {
        background-color: white;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
    }
}
</style>
